import { setAddress } from '../map';
import { getAddressByLocation } from '../../lib/mapService';

/**
 * Set address.
 * @param {!object} coordinate A coordinate.
 * @return {function} action dispatcher.
 */
export default (coordinate) => async (dispatch, getState) => {
  const { map } = getState();
  const address = await getAddressByLocation(coordinate);

  if (address === map.address) {
    return;
  }

  if (address) {
    document.title = `Coastline Paradox - ${address}`;
  } else {
    document.title = 'Coastline Paradox';
  }

  dispatch(setAddress(address));
};
